var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJustcallOffline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM9.8291 6.75C10.08 6.75 10.3033 6.91047 10.3828 7.14844L11.2568 9.77051C11.3483 10.0458 11.2234 10.3468 10.9639 10.4766L9.64746 11.1348C10.2904 12.5607 11.4393 13.7096 12.8652 14.3525L13.5234 13.0361C13.6532 12.7766 13.9542 12.6517 14.2295 12.7432L16.8516 13.6172C17.0895 13.6967 17.25 13.92 17.25 14.1709V16.083C17.25 16.7273 16.7273 17.25 16.083 17.25H15.5C10.6675 17.25 6.75 13.3325 6.75 8.5V7.91699C6.75 7.27266 7.27266 6.75 7.91699 6.75H9.8291Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.3496C21.5681 14.3496 23.6504 16.4319 23.6504 19C23.6504 21.5681 21.5681 23.6504 19 23.6504C16.4319 23.6504 14.3496 21.5681 14.3496 19C14.3496 16.4319 16.4319 14.3496 19 14.3496Z",
    fill: "#C2C5C5",
    stroke: "#0D1718",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustcallOffline);
export default __webpack_public_path__ + "static/media/justcall-offline.a3db0f1bdf96d14fbf51505b8ca3f835.svg";
export { ForwardRef as ReactComponent };